import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { JwtAuthService } from "../services/auth/jwt-auth.service";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class HomeRedirectGuard  {
    constructor(
        private router: Router,
        private jwtAuth: JwtAuthService
    ) { }

    canActivate(
    ): Observable<UrlTree> | UrlTree {

        if (!this.jwtAuth.isLoggedIn()) {
            return this.router.createUrlTree(['/sessions/signin']);
        }

        return this.jwtAuth.getUserRole().pipe(
            map(() => {
                const defaultPageUrl = this.jwtAuth.getDefaultPageUrl();
                return this.router.createUrlTree([defaultPageUrl]);
            }),
            catchError(() => {
                return of(this.router.createUrlTree(['/sessions/signin']));
            })
        );
    }
}
